import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const TdUI = styled('td')(mapStylesProp);
